import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { contx } from '../../../App';
import img1 from '../../../assets/marketing/1.png';
import img2 from '../../../assets/marketing/2.png';
import img3 from '../../../assets/marketing/3.png';

const Marketing = () => {
  const { lang } = React.useContext(contx);
  const isAr = lang === 'ar';

  const heroTitle = isAr
    ? 'حياتك المالية أسهل مع TMTM'
    : 'Make Your Financial Life Easier with TMTM';

  const heroSubtitle = isAr
    ? 'اشترِ الآن وادفع لاحقًا بكل مرونة وأمان. قسّط مشترياتك وتحكم بمدفوعاتك بخطوات بسيطة.'
    : 'Buy now and pay later with flexibility and safety. Split your purchases and control your payments in a few simple steps.';

  const features = isAr
    ? [
        {
          title: 'حاسبة أقساط دقيقة وفورية',
          body: 'احسب قيمة القسط الشهري بسهولة قبل اتخاذ قرار الشراء. اختر نوع الخدمة، أدخل المبلغ، وحدد الخطة المناسبة لك لتظهر لك تفاصيل التقسيط فورًا.',
          img: img2,
        },
        {
          title: 'لوحة تحكم ذكية وسهلة الاستخدام',
          body: 'تابع جميع خدمات التقسيط الخاصة بك من شاشة واحدة. اطّلع على حالة طلباتك، الخدمات المتاحة، وأحدث العروض بكل وضوح وسلاسة.',
          img: img3,
        },
        {
          title: 'حماية متقدمة عبر رمز MPIN',
          body: 'أمان حسابك أولوية لدينا. يتم تأمين الدخول وتنفيذ العمليات عبر رمز تعريف شخصي (MPIN) لضمان حماية بياناتك ومعاملاتك المالية.',
          img: img1,
        },
      ]
    : [
        {
          title: 'Accurate, Instant Installment Calculator',
          body: 'Easily calculate your monthly installment before you decide to buy. Choose the service type, enter the amount, and pick the plan that suits you to see the details instantly.',
          img: img2,
        },
        {
          title: 'Smart, Easy-to-Use Dashboard',
          body: 'Track all your installment services from a single screen. See the status of your requests, available services, and the latest offers clearly and smoothly.',
          img: img3,
        },
        {
          title: 'Advanced Protection with MPIN',
          body: 'Your account security is our priority. Access and operations are protected with a personal MPIN code to keep your data and financial transactions safe.',
          img: img1,
        },
      ];

  return (
    <div style={{ width: '100%', minHeight: '60vh', backgroundColor: '#F2F2F2' }} dir={isAr ? 'rtl' : 'ltr'}>
      <Container className="py-5">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ color: '#005247', marginBottom: '1rem' }}>{heroTitle}</h1>
          <p style={{ fontSize: '1.1rem', color: '#555', maxWidth: 700, margin: '0 auto' }}>{heroSubtitle}</p>
        </div>

        <Row className="g-4">
          {features.map((item, idx) => (
            <Col key={idx} md={4} sm={12}>
              <Card
                style={{
                  borderRadius: 22,
                  border: '1px solid #ededed',
                  backgroundColor: '#F5F5F5',
                  height: '100%',
                  overflow: 'hidden',
                }}
              >
                {item.img && (
                  <Card.Img
                    variant="top"
                    src={item.img}
                    alt={item.title}
                    style={{ objectFit: 'cover', maxHeight: 220 }}
                  />
                )}
                <Card.Body>
                  <Card.Title style={{ color: '#424242', fontSize: '1.2rem', marginBottom: '0.75rem' }}>
                    {item.title}
                  </Card.Title>
                  <Card.Text style={{ color: '#8c8c8c', lineHeight: 1.6 }}>{item.body}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Marketing;

